<nav {...$$restProps}
     class={`${$$restProps.class ?? ''} paper-navbar`}
     class:border class:fixed
     class:split-nav={split}>
  {#if $$slots.brand}
    <div class="nav-brand">
      <slot name="brand" />
    </div>
  {/if}
  <div class="collapsible">
    <button on:click={collapse}>☰</button>
    <div class="collapsible-body" class:open>
      <slot />
    </div>
  </div>
</nav>

<script >export let border = true;
export let fixed = false;
export let split = true;
let open = false;
function collapse() {
    open = !open;
}
</script>

<style >/* Papercss removes border of buttons in .collapsible */
.collapsible > button {
  border: 2px solid var(--primary);
}
.collapsible-body.open {
  margin: 0;
  max-height: 960px;
  opacity: 1;
  padding: 0;
}

:global(.paper-navbar li a.paper-btn) {
  display: initial;
}</style>
